import { MantineThemeOverride, Pill } from '@mantine/core';

const theme: MantineThemeOverride = {
  fontFamily: 'Manrrope, sans-serif',
  headings: {
    fontFamily: 'Manrope, sans-serif',
  },

  black: '#444',

  colors: {
    brand: [
      '#CCEFE5',
      '#AAE2D1',
      '#88D1BC',
      '#66BFA6',
      '#44A98F',
      '#229176',
      '#00765b',
      '#006E51',
      '#005E43',
      '#004731',
    ],
  },

  primaryColor: 'brand',

  cursorType: 'pointer',

  components: {
    Pill: Pill.extend({
      styles: {
        root: {
          backgroundColor: '#229176',
          color: '#fff',
        },
      },
    }),
  },
};

export default theme;
